import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

function TableSkeleton() {
  return (
    <div className="bg-[hsl(var(--card))] rounded-2xl border border-[hsl(var(--border))] p-5">
      <Skeleton className="h-4 w-36 mb-4" />
      <div className="space-y-0">
        <div className="flex items-center gap-4 py-3 border-b border-[hsl(var(--border))]">
          <Skeleton className="h-3 w-[200px]" />
          <Skeleton className="h-3 w-20 mx-auto" />
          <Skeleton className="h-3 w-20 mx-auto" />
          <Skeleton className="h-3 w-20 mx-auto" />
          <Skeleton className="h-3 w-16 mx-auto" />
        </div>
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="flex items-center gap-4 py-3.5">
            <Skeleton className="h-3.5 w-[180px]" />
            <Skeleton className="h-3.5 w-16 mx-auto" />
            <Skeleton className="h-3.5 w-16 mx-auto" />
            <Skeleton className="h-3.5 w-14 mx-auto" />
            <Skeleton className="h-5 w-10 rounded-full mx-auto" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function VideoDuelSkeleton() {
  return (
    <div className="space-y-6">
      <TableSkeleton />
    </div>
  );
}
